__turbopack_context__.v({
  "blink": "Credits-module-scss-module__0xM1Ba__blink",
  "borderTop": "Credits-module-scss-module__0xM1Ba__borderTop",
  "credit": "Credits-module-scss-module__0xM1Ba__credit",
  "credits": "Credits-module-scss-module__0xM1Ba__credits",
});
